import { createSlice } from "@reduxjs/toolkit";
const initialState = { subscription_id: "" };

const planstatisticsReducer = createSlice({
  name: "planstatisticsReducer",
  initialState,
  reducers: {
    planStatisticsState(state, action) {
      state.subscription_id = action.payload;
    },
  },
});
export const { planStatisticsState } = planstatisticsReducer.actions;
export default planstatisticsReducer.reducer;